import React from "react"
import {
	ArrowForwardIos as GoToConstructionIcon,
	Edit as EditIcon
} from "@material-ui/icons"
import { Grid, IconButton, Link } from "@material-ui/core"

import { MoreOptionsMenu } from "@/components"
import { MoreOptionsMenuOptionData } from "@/components/MoreOptionsMenu"

import { AgentFormattedForList } from "@/services/AgentService"

import useStyles from "@/pages/Admin/Agent/AgentList/AgentListItem/AgentListActions/styles"
import { InboxV2Links } from "@/utils/link"

type AgentListActionsProps = {
	agent: AgentFormattedForList
	onEditAgentProfile: () => void
}

const AgentListActions: React.FC<AgentListActionsProps> = (props) => {
	const { agent, onEditAgentProfile } = props

	const classes = useStyles()

	const agentPath = `${InboxV2Links.agentDetails}/${agent.id}`

	const getOptionsMenu = () => {
		const options: MoreOptionsMenuOptionData[] = [
			{
				title: "Alterar Nome",
				icon: <EditIcon />,
				showIcon: true,
				onClick: onEditAgentProfile
			}
		]

		return options
	}

	return (
		<Grid container spacing={1} justifyContent="flex-end">
			<Grid item>
				<Grid container alignItems="center" justifyContent="flex-end">
					<Link
						href={agentPath}
						style={{ textDecoration: "none" }}
						target="_blank"
					>
						<IconButton className={classes.listItemButton}>
							<GoToConstructionIcon className={classes.editIcon} />
						</IconButton>
					</Link>
				</Grid>
			</Grid>

			<Grid item>
				<Grid className={classes.listItemMoreOptions}>
					<MoreOptionsMenu options={getOptionsMenu()} />
				</Grid>
			</Grid>
		</Grid>
	)
}

export default AgentListActions
